import { styled } from "styled-components";

export const DarkSwitchWrapper = styled.div`
  position: fixed;
  right: 40px;
  bottom: 40px;
  z-index: 100;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;
